import initializeWeatherFaqTelemetry from './components/weather-faq-telemetry';
import initializeWeatherSummaryTelemetry from './components/weather-summary-telemetry';

initializeWeatherFaqTelemetry();
initializeWeatherSummaryTelemetry();
import accordionFaqHome from './components/accordion-faq-home';
import accordionNearby2026 from './components/accordion-nearby-2026';
import alertNews from './components/alert-news';
import backgroundBanner from './components/background-banner';
import carousel from './components/carousel';
import cityBtnModal from './components/city-btn-modal';
import common from './components/common';
import extremeAlertsModal from './components/extreme-alerts-modal';
import { initializeForecastFavoriteButton } from './components/favorite-city-utils';
import favoriteCitiesHomepage from './components/favorite-cities-homepage';
import geolocation from './components/geolocation';
import geolocationInstructionsModal from './components/geolocation-instructions-modal';
import handleCityLinkClick from './components/fift-city-link';
import header from './components/header';
import headerInfoBar from './components/header-info-bar';
import locationsModal from './components/locations-modal';
import modal from './components/modal';
import sidebar from './components/sidebar';
import thirtyDaysModal from './components/thirty-days-modal';
import user from './components/user';
import './monkey-patch';

alertNews.getNewestAlert();
alertNews.closeAlert();
backgroundBanner.renderBackgroundBanner();
carousel.initCarousel();
common.autocompleteSearchV2();
common.setAlertStyle();
common.onScroll();
common.controlMobileSearch();
common.closeBanner();
common.controlMobileMenu();
common.backToTopButton();
//common.renderBanner()
common.initMetrics();
common.activeTab();
common.centerAgg15Nav();
common.activeMobileTab();
common.handleFavoriteButtonClick();
common.applyDataStyleAttributes();
common.applyWindRotationIndicators();
common.viewData();
geolocation.userGeolocation();
modal.controlModal();
user.controlLoggedMenu();
user.renderWeatherNowByFavoritesLocalesBreadcrumb();
user.controlFavoritesLocalesBreadcrumb();
header.controlMenu();

accordionFaqHome.handleAnswerOpening({ trackingKey: 'FaqRain' });
accordionNearby2026.init();
handleCityLinkClick();
extremeAlertsModal.init();

sidebar.init();
headerInfoBar.init();
locationsModal.init();
geolocationInstructionsModal.init();
thirtyDaysModal.init();
initializeForecastFavoriteButton();
locationsModal.init();
geolocationInstructionsModal.init();
cityBtnModal.init();
favoriteCitiesHomepage.init();
